"use client";

import { ResponsiveDialog } from "@repo/ui/components/responsive-dialog";
import { useTranslations } from "next-intl";
import { Button } from "@/components/ui/button";
import type { RescheduledDiet } from "@/features/cart/hooks/use-reschedule-unavailable-dates";
import { CartRescheduleRow } from "./cart-reschedule-row";

export const CartRescheduleDialog = ({
  items,
  onClose,
  open,
}: {
  items: RescheduledDiet[];
  onClose: () => void;
  open: boolean;
}) => {
  const t = useTranslations();

  return (
    <ResponsiveDialog
      closeLabel={t("cart.rescheduleDialog.close")}
      dialogClassName="gap-0 overflow-hidden p-0 md:w-[calc(100%-2rem)] md:max-w-140"
      footer={
        <Button
          className="max-md:w-full"
          onClick={onClose}
          size="wide"
          type="button"
          variant="secondary"
        >
          {t("cart.rescheduleDialog.confirm")}
        </Button>
      }
      footerClassName="border-t px-4 py-4 md:px-6"
      headerClassName="border-b px-4 py-3.5 md:px-6 md:py-5"
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          onClose();
        }
      }}
      open={open}
      title={t("cart.rescheduleDialog.title")}
      titleClassName="font-medium text-brand-green1-300 text-xl leading-7 tracking-normal md:text-2xl md:leading-8"
    >
      <div className="space-y-4 p-4 md:space-y-6 md:p-6">
        <p className="text-base text-brand-green1-300">
          {t("cart.rescheduleDialog.description")}
        </p>
        <ul className="divide-y divide-brand-grey2 rounded-xl bg-background-page-secondary p-3">
          {items.map((item) => (
            <CartRescheduleRow item={item} key={item.id} />
          ))}
        </ul>
      </div>
    </ResponsiveDialog>
  );
};
